import React from 'react';

import { Layout } from '@.layout';
import { UserForm } from '@/Components/Partials/User';
import { LinkHelper } from '@/Services';

import S from './UserCreatePage.module.scss';

export const UserCreatePage = () => {
    const breadcrumbs = [
        { name: 'Users', link: LinkHelper.settingsUsers },
        { name: 'Add', current: true },
    ];

    return (
        <Layout contentClassName={S.root} name="settings" breadcrumbs={breadcrumbs} small>
            <UserForm title="Adding user" />
        </Layout>
    );
};
